import { render, staticRenderFns } from "./copyBottun.vue?vue&type=template&id=5a545233&scoped=true"
import script from "./copyBottun.vue?vue&type=script&lang=js"
export * from "./copyBottun.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a545233",
  null
  
)

export default component.exports